import MercadoPago from './MercadoPago'

Vue.prototype.$state.$mercadoPago = new Vue(MercadoPago)

Vue.component('mercadopago-web-form', () => import(/* webpackChunkName: "mercadopago-web-form" */ '@modulesPages/MercadoPago/Resources/assets/js/Forms/WebForm'))